<template>
  <button v-if="showFeedbackButton" ref="feedbackButtonRef" type="button">
    <slot />
  </button>
</template>
<script setup lang="ts">
import * as Sentry from "@sentry/vue";
import { onMounted, ref, useTemplateRef } from "vue";
const showFeedbackButton = ref(true);
const feedbackButtonElement = useTemplateRef("feedbackButtonRef");

const feedback = Sentry.getFeedback();
if (!feedback || !feedbackButtonElement.value) {
  console.warn("Sentry feedback widget is not available.");
}
onMounted(() => {
  if (feedback && feedbackButtonElement.value) {
    feedback.attachTo(feedbackButtonElement.value);
  }
});
</script>
